import type { Terminal } from '../terminal';

const VALID_PASSWORDS = ['JOSHUA', 'FALKEN', 'CPE1704TKS'];

async function runLoginScreen(terminal: Terminal): Promise<void> {
  let authenticated = false;
  let attempts = 0;

  while (!authenticated) {
    const input = await terminal.waitForInput('LOGON: ');

    if (VALID_PASSWORDS.includes(input.toUpperCase())) {
      await terminal.pause(500);
      await terminal.println('');
      await terminal.println('GREETINGS PROFESSOR FALKEN.', { cssClass: 'bright' });
      await terminal.pause(800);
      authenticated = true;
    } else if (input.toUpperCase() === 'HELP GAMES') {
      await terminal.println('');
      await terminal.println('\'GAMES\' REFERS TO MODELS, SIMULATIONS AND GAMES');
      await terminal.println('WHICH HAVE TACTICAL AND STRATEGIC APPLICATIONS.');
      await terminal.println('');
    } else {
      attempts++;
      await terminal.println('');
      await terminal.println('IDENTIFICATION NOT RECOGNIZED BY SYSTEM', { cssClass: 'warning' });
      await terminal.println(`--Loss: CONNECT AUTHORIZATION-- (${attempts})`, { cssClass: 'dim' });
      await terminal.println('');

      if (attempts >= 5) {
        await terminal.println('HINT: TRY "JOSHUA"', { cssClass: 'dim' });
        await terminal.println('');
      }
    }
  }
}

export { runLoginScreen };
